import { makeStyles, Theme } from "@material-ui/core";
import { tesaDarkRedError } from "../../../../../../../styles/colors";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    "& h2, p": {
      margin: 0,
    },
  },
  dropdownItems: {
    "& div.MuiFormControl-root": {
      margin: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 0`,
    },
  },
  matrixConfigurationError: {
    color: tesaDarkRedError,
  },
}));

export default useStyles;
